// App.js
import { auth } from "./firebase"; // Import the initialized instance
import { getRedirectResult, GoogleAuthProvider, signInWithRedirect } from "firebase/auth";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    // This runs on load. Because 'auth' is already initialized 
    // correctly in firebase.js, this will not throw an argument-error.
    getRedirectResult(auth)
      .then((result) => {
        if (result) console.log("User signed in:", result.user);
      })
      .catch((error) => console.error(error));
  }, []);

  const login = () => {
    const provider = new GoogleAuthProvider();
    signInWithRedirect(auth, provider);
  };

  return <button onClick={login}>Login</button>;
}

export default App;